import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewContainerRef } from '@angular/core';

import { IMCMapView } from '../../../classes/mcMapView';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { ILayerCatalogItem, IMapcoreProps, IQuery } from '../../../types';
import { BaseComponent } from '../../base.component';

/* tslint:disable:template-cyclomatic-complexity */
@Component({
    selector: 'mc-layer-catalog-item-ng',
    styleUrls: ['./layer-catalog-item.component.scss'],
    templateUrl: './layer-catalog-item.component.html'
})
export class LayerCatalogItemComponent extends BaseComponent implements AfterViewInit {
    get includeGoogleAnalytics() { return false; }

    @Input() mapViewRef: IMCMapView;
    @Input() layerCatalogItem: ILayerCatalogItem;
    @Input() layerItemType: string;
    @Output() readonly closeWindowEvent = new EventEmitter<boolean>();
    @Output() readonly checkChangedEvent = new EventEmitter<ILayerCatalogItem>();

    detailsExpanded: boolean = false;
    layerData: ILayerDetails = null;
    loading: boolean = false;
    error: boolean = false;

    get includeEsriCss() { return false; }
    get includeOverrideCss() { return false; }

    constructor(_vcr: ViewContainerRef,
        private readonly layerService: LayerService,
        private readonly cdr: ChangeDetectorRef,
        private readonly toSqlStringService: ToSqlStringService) { super(_vcr, true); }

    async ngAfterViewInit() {
        this.mapViewRef = this.mapViewRef ? this.mapViewRef : await this.setupMapViewRef(this.mapViewRef);
    }

    toggle() {
        this.layerCatalogItem.expanded = !this.layerCatalogItem.expanded;
        if (this.layerCatalogItem.layer) {
            this.toggleDetails();
        }
    }

    async toggleDetails() {
        if (!this.layerCatalogItem.ispetl) {
            this.detailsExpanded = !this.detailsExpanded;
            if (!this.layerData && this.layerCatalogItem.layer) {
                if (this.layerItemType === 'External') {
                    this.layerData = this.layerCatalogItem.layer;
                } else {
                    await this.getLayerData();
                }
            }
        }
    }

    itemSelectedChanged() {
        this.checkChangedEvent.emit({ name: this.layerCatalogItem.name, isSelected: this.layerCatalogItem.isSelected });
    }

    checkChanged() {
        this.checkChangedEvent.emit(this.layerCatalogItem);
    }

    async getLayerData() {
        this.error = false;
        this.loading = true;
        const layerId = this.layerCatalogItem.layer.id;
        const props = 'columns {name, databaseDataType, databaseDataLength} name description featureEndpoints{url} lastEditedDate queryJSON recordCount maximumRecordUpdateDate hoverColumnList tables{id geometryType name owner }';
        this.cdr.detectChanges();
        try {
            const data = await this.layerService.getLayersFromApi([layerId], props);
            this.layerData = data[0];
            let query: IQuery = {};
            if (this.layerData.queryJSON && this.layerData.queryJSON !== 'null') {
                query = JSON.parse(this.layerData.queryJSON);
            }
            if (!this.layerData.maximumRecordUpdateDate) {
                this.layerData.maximumRecordUpdateDate = 'Unknown';
            }
            this.layerData.sql = this.toSqlStringService.getSql(query,
                this.layerData.columns,
                this.layerData.tables.sort((a, b) => a.geometryType.localeCompare(b.geometryType))[0]);
            this.layerData.tableNames = this.layerData.tables ? this.layerData.tables.map(t => t.name) : this.layerData.tableNames;
            this.cdr.detectChanges();
            this.loading = false;
        }
        catch (err) {
            this.error = true;
            throw err;
        }
        finally {
            this.cdr.detectChanges();
            this.loading = false;
        }

    }
}

interface ILayerDetails extends IMapcoreProps {
    maximumRecordUpdateDate?: Date | string;
    recordCount?: number;
    sql?: string;
}
